import PropTypes from 'prop-types';

const aiConfirmCardLabelsPropType = PropTypes.shape({
  approve: PropTypes.string,
  dismiss: PropTypes.string,
  reasonPlaceholder: PropTypes.string,
  reasonSubmit: PropTypes.string,
  reasonCancel: PropTypes.string,
  slaGroupLabel: PropTypes.string,
  slaGroupPlaceholder: PropTypes.string,
  slaGroupPrompt: PropTypes.string,
});

export const aiConfirmCardPropTypes = {
  onSubmit: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  entityId: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isSlaSelectionRequired: PropTypes.bool,
  labels: aiConfirmCardLabelsPropType,
};
